import { render, staticRenderFns } from "./TechSupport.vue?vue&type=template&id=00454338&scoped=true&"
import script from "./TechSupport.vue?vue&type=script&lang=js&"
export * from "./TechSupport.vue?vue&type=script&lang=js&"
import style0 from "./TechSupport.vue?vue&type=style&index=0&id=00454338&scoped=true&lang=css&"
import style1 from "./TechSupport.vue?vue&type=style&index=1&id=00454338&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00454338",
  null
  
)

export default component.exports